import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-34530443")

_pushScopeId("data-v-34530443")
const _hoisted_1 = { class: "access-tips" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.$wordList.AccountSetting,
    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close'))),
    onSubmit: _ctx.submit
  }, {
    default: _withId(() => [
      _createVNode(_component_el_form, {
        "label-position": _ctx.$formLabelPosition,
        ref: "form",
        model: _ctx.formData
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.PermissionGranted
          }, {
            default: _withId(() => [
              _createVNode(_component_el_radio, {
                modelValue: _ctx.formData.IsPwdFreeLogin,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.IsPwdFreeLogin = $event)),
                label: 1
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOn), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_radio, {
                modelValue: _ctx.formData.IsPwdFreeLogin,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.IsPwdFreeLogin = $event)),
                label: 0
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOff), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, null, {
            default: _withId(() => [
              _createVNode("p", _hoisted_1, _toDisplayString(_ctx.$wordList.PermissionGrantedTips), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label-position", "model"])
    ]),
    _: 1
  }, 8, ["title", "onSubmit"]))
})